import style from "./style.module.css";

const MissingAssignment = () => {
  return <div className={style.container}></div>;
};

export default MissingAssignment;
